module.exports = __webpack_public_path__ + "static/media/android.ae4fd2b1.svg";